var SwaggerUIBundle = require("swagger-ui-dist").SwaggerUIBundle;
document.addEventListener("turbolinks:load", function () {
  if ($("#swagger").length) {
    SwaggerUIBundle({
      dom_id: "#swagger",
      url: "/v1/swagger",
    });
  }
});
